const copyrightYear = (baseYear) => {
    const currentYear = new Date().getFullYear();
    return currentYear <= baseYear ? baseYear : baseYear + "-" + currentYear;
}

export {copyrightYear};